// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Gg52e","image":"Header_image__1mH1x","name":"Header_name__xqOKY","info":"Header_info__1GOK8","infoRow":"Header_infoRow__2CC6g"};